import { render, staticRenderFns } from "./Derby.vue?vue&type=template&id=0171a0c9&scoped=true&"
import script from "./Derby.vue?vue&type=script&lang=js&"
export * from "./Derby.vue?vue&type=script&lang=js&"
import style0 from "./Derby.vue?vue&type=style&index=0&id=0171a0c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171a0c9",
  null
  
)

export default component.exports